const parts = ["root", "toolbar", "content"];

function baseStyle() {
  return {
    root: {
      border: "1px solid",
      borderColor: "gray.450",
      borderRadius: "10px",
      bg: "gray.50",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
    },
    toolbar: {
      display: "flex",
      gap: 1,
      p: 1,
      borderBottom: "1px solid",
      borderColor: "gray.450",
      bg: "white",
      flexWrap: "wrap",
    },
    content: {
      p: 3,
      flex: 1,
      minH: 0,
      overflow: "auto",
      fontSize: "md",
      color: "gray.800",
      "& .ProseMirror": {
        outline: "none",
        minH: "100%",
      },
      "& .ProseMirror p": {
        marginBottom: "0.5em",
      },
      "& .ProseMirror strong": {
        fontWeight: 700,
      },
      "& .ProseMirror hr": {
        my: 3,
        borderColor: "gray.300",
      },
      "& .ProseMirror ul, & .ProseMirror ol": {
        pl: 5,
        mb: 2,
      },
      "& .ProseMirror li": {
        mb: 1,
      },
    },
  };
}

const sizes = {
  md: {
    content: {
      minH: "130px",
    },
  },
};

const richTextTheme = {
  parts,
  baseStyle,
  sizes,
  defaultProps: {
    size: "md",
  },
};

export { richTextTheme };
